<template>
    <q-icon v-if="show" name="mdi-alert" color="negative" size="sm" class="float-right q-ma-sm">
        <q-tooltip v-if="errorMessage" content-class="bg-negative">{{ errorMessage }}</q-tooltip>
    </q-icon>
</template>
<script>
    export default {
        name: 'error-icon',
        props: {
            show: {
                type: Boolean,
                default: true
            },
            errorMessage: String,
        }

    }
</script>
